import { CompanyInfoBadge } from '@aibees/elephant/components';
import { LimitTypography } from '@aibees/elephant/components/limit-typography';
import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { useCompanyVisibilityState } from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { CompanyDescriptionProps as Props } from './types';

export const CompanyDescription = memo(
  ({ className, sx, isDetailPopover, data, showCompanyInfoBadge }: Props) => {
    const { api } = useCompanyReadDataContext();
    const sourceData = isDetailPopover ? data : api?.data;
    const description = sourceData?.summary?.description;
    const { isNoLongerEmployed } = useCompanyVisibilityState();

    return (
      <>
        <Styled.Wrapper
          className={classnames('CompanyDescription', className)}
          sx={sx}
        >
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Typography variant="body3" color="grey.700" fontWeight={700}>
              Company Overview:
            </Typography>
            {isNoLongerEmployed && showCompanyInfoBadge && <CompanyInfoBadge />}
          </Stack>

          {api?.isFetching ? (
            <Skeleton animation="wave" variant="rounded" />
          ) : (
            <>
              {description && (
                <Box>
                  <LimitTypography
                    value={description}
                    wordLimit={isDetailPopover ? 14 : 16}
                    fontWeight={400}
                    color="grey.700"
                    variant="body4"
                  />
                </Box>
              )}
              {!description && (
                <Typography variant="body4" color="grey.400">
                  No information is available.
                </Typography>
              )}
            </>
          )}
        </Styled.Wrapper>
        <Divider />
      </>
    );
  }
);

CompanyDescription.displayName = 'CompanyDescription';
